import { render, staticRenderFns } from "./CampDetails.vue?vue&type=template&id=2d7a9026&scoped=true&"
import script from "./CampDetails.vue?vue&type=script&lang=js&"
export * from "./CampDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampDetails.vue?vue&type=style&index=0&id=2d7a9026&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a9026",
  null
  
)

export default component.exports